var cov_ofz6c942s = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Carousel/index.tsx",
      hash = "f7a67896f5066a4c4e453ba461482d10d5865a38",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Carousel/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 44
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "1": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 16
        }
      },
      "2": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 45,
          column: 5
        }
      },
      "3": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 38
        }
      },
      "4": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 36
        }
      },
      "5": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 40
        }
      },
      "6": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 42
        }
      },
      "7": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 44
        }
      },
      "8": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 29
        }
      },
      "9": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 16
        }
      },
      "10": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 62,
          column: 5
        }
      },
      "11": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 18
        }
      },
      "12": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 32
        }
      },
      "13": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 15
        }
      },
      "14": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 32
        }
      },
      "15": {
        start: {
          line: 71,
          column: 26
        },
        end: {
          line: 71,
          column: 32
        }
      },
      "16": {
        start: {
          line: 72,
          column: 25
        },
        end: {
          line: 72,
          column: 35
        }
      },
      "17": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "18": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 17
        }
      },
      "19": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 77,
          column: 18
        }
      },
      "20": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 25
        }
      },
      "21": {
        start: {
          line: 82,
          column: 23
        },
        end: {
          line: 82,
          column: 33
        }
      },
      "22": {
        start: {
          line: 83,
          column: 24
        },
        end: {
          line: 83,
          column: 34
        }
      },
      "23": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 32
        }
      },
      "24": {
        start: {
          line: 84,
          column: 26
        },
        end: {
          line: 84,
          column: 32
        }
      },
      "25": {
        start: {
          line: 86,
          column: 44
        },
        end: {
          line: 86,
          column: 83
        }
      },
      "26": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 93,
          column: 5
        }
      },
      "27": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 88,
          column: 27
        }
      },
      "28": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 14
        }
      },
      "29": {
        start: {
          line: 90,
          column: 11
        },
        end: {
          line: 93,
          column: 5
        }
      },
      "30": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 28
        }
      },
      "31": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 27
        }
      },
      "32": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 61
        }
      },
      "33": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 26
        }
      },
      "34": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 101,
          column: 8
        }
      },
      "35": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 101,
          column: 8
        }
      },
      "36": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 39
        }
      },
      "37": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 39
        }
      },
      "38": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 116,
          column: 5
        }
      },
      "39": {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 114,
          column: 33
        }
      },
      "40": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 26
        }
      },
      "41": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 40
        }
      },
      "42": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 27
        }
      },
      "43": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 15
        }
      },
      "44": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 129,
          column: 28
        }
      },
      "45": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 130,
          column: 16
        }
      },
      "46": {
        start: {
          line: 134,
          column: 29
        },
        end: {
          line: 134,
          column: 39
        }
      },
      "47": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 139,
          column: 6
        }
      },
      "48": {
        start: {
          line: 136,
          column: 6
        },
        end: {
          line: 138,
          column: 13
        }
      },
      "49": {
        start: {
          line: 143,
          column: 49
        },
        end: {
          line: 143,
          column: 59
        }
      },
      "50": {
        start: {
          line: 144,
          column: 24
        },
        end: {
          line: 144,
          column: 34
        }
      },
      "51": {
        start: {
          line: 145,
          column: 22
        },
        end: {
          line: 145,
          column: 82
        }
      },
      "52": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 148,
          column: 5
        }
      },
      "53": {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 83
        }
      },
      "54": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 15
        }
      },
      "55": {
        start: {
          line: 153,
          column: 49
        },
        end: {
          line: 153,
          column: 59
        }
      },
      "56": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 156,
          column: 5
        }
      },
      "57": {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 41
        }
      },
      "58": {
        start: {
          line: 157,
          column: 24
        },
        end: {
          line: 157,
          column: 34
        }
      },
      "59": {
        start: {
          line: 158,
          column: 22
        },
        end: {
          line: 158,
          column: 112
        }
      },
      "60": {
        start: {
          line: 160,
          column: 17
        },
        end: {
          line: 164,
          column: 6
        }
      },
      "61": {
        start: {
          line: 161,
          column: 6
        },
        end: {
          line: 163,
          column: 10
        }
      },
      "62": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 167,
          column: 5
        }
      },
      "63": {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 166,
          column: 20
        }
      },
      "64": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 50
        }
      },
      "65": {
        start: {
          line: 172,
          column: 42
        },
        end: {
          line: 172,
          column: 52
        }
      },
      "66": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 173,
          column: 31
        }
      },
      "67": {
        start: {
          line: 173,
          column: 20
        },
        end: {
          line: 173,
          column: 31
        }
      },
      "68": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 179,
          column: 5
        }
      },
      "69": {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 183,
          column: 61
        }
      },
      "70": {
        start: {
          line: 185,
          column: 33
        },
        end: {
          line: 185,
          column: 43
        }
      },
      "71": {
        start: {
          line: 186,
          column: 26
        },
        end: {
          line: 186,
          column: 36
        }
      },
      "72": {
        start: {
          line: 187,
          column: 22
        },
        end: {
          line: 187,
          column: 96
        }
      },
      "73": {
        start: {
          line: 189,
          column: 4
        },
        end: {
          line: 201,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 47
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 39
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        },
        loc: {
          start: {
            line: 54,
            column: 22
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 54
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 23
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 59
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        loc: {
          start: {
            line: 65,
            column: 25
          },
          end: {
            line: 68,
            column: 3
          }
        },
        line: 65
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        },
        loc: {
          start: {
            line: 70,
            column: 24
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 70
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 75,
            column: 33
          },
          end: {
            line: 75,
            column: 34
          }
        },
        loc: {
          start: {
            line: 75,
            column: 39
          },
          end: {
            line: 77,
            column: 7
          }
        },
        line: 75
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 81,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        loc: {
          start: {
            line: 81,
            column: 23
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 81
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        },
        loc: {
          start: {
            line: 104,
            column: 12
          },
          end: {
            line: 106,
            column: 3
          }
        },
        line: 104
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 108,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        },
        loc: {
          start: {
            line: 108,
            column: 13
          },
          end: {
            line: 110,
            column: 3
          }
        },
        line: 108
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        },
        loc: {
          start: {
            line: 112,
            column: 9
          },
          end: {
            line: 117,
            column: 3
          }
        },
        line: 112
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 119,
            column: 2
          },
          end: {
            line: 119,
            column: 3
          }
        },
        loc: {
          start: {
            line: 119,
            column: 10
          },
          end: {
            line: 121,
            column: 3
          }
        },
        line: 119
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 123,
            column: 22
          },
          end: {
            line: 123,
            column: 23
          }
        },
        loc: {
          start: {
            line: 123,
            column: 28
          },
          end: {
            line: 126,
            column: 3
          }
        },
        line: 123
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 128,
            column: 22
          },
          end: {
            line: 128,
            column: 23
          }
        },
        loc: {
          start: {
            line: 128,
            column: 28
          },
          end: {
            line: 131,
            column: 3
          }
        },
        line: 128
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 3
          }
        },
        loc: {
          start: {
            line: 133,
            column: 16
          },
          end: {
            line: 140,
            column: 3
          }
        },
        line: 133
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 135,
            column: 53
          },
          end: {
            line: 135,
            column: 54
          }
        },
        loc: {
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 138,
            column: 13
          }
        },
        line: 136
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 142,
            column: 2
          },
          end: {
            line: 142,
            column: 3
          }
        },
        loc: {
          start: {
            line: 142,
            column: 26
          },
          end: {
            line: 150,
            column: 3
          }
        },
        line: 142
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 152,
            column: 2
          },
          end: {
            line: 152,
            column: 3
          }
        },
        loc: {
          start: {
            line: 152,
            column: 20
          },
          end: {
            line: 169,
            column: 3
          }
        },
        line: 152
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 160,
            column: 39
          },
          end: {
            line: 160,
            column: 40
          }
        },
        loc: {
          start: {
            line: 161,
            column: 6
          },
          end: {
            line: 163,
            column: 10
          }
        },
        line: 161
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 171,
            column: 3
          }
        },
        loc: {
          start: {
            line: 171,
            column: 16
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 171
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        loc: {
          start: {
            line: 182,
            column: 11
          },
          end: {
            line: 202,
            column: 3
          }
        },
        line: 182
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }, {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }],
        line: 60
      },
      "1": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 22
          }
        }, {
          start: {
            line: 60,
            column: 26
          },
          end: {
            line: 60,
            column: 40
          }
        }],
        line: 60
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 32
          }
        }, {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 32
          }
        }],
        line: 71
      },
      "3": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }],
        line: 73
      },
      "4": {
        loc: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 20
          }
        }, {
          start: {
            line: 73,
            column: 24
          },
          end: {
            line: 73,
            column: 38
          }
        }],
        line: 73
      },
      "5": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 32
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 32
          }
        }],
        line: 84
      },
      "6": {
        loc: {
          start: {
            line: 86,
            column: 44
          },
          end: {
            line: 86,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 86,
            column: 61
          },
          end: {
            line: 86,
            column: 70
          }
        }, {
          start: {
            line: 86,
            column: 73
          },
          end: {
            line: 86,
            column: 83
          }
        }],
        line: 86
      },
      "7": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        }, {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        }],
        line: 87
      },
      "8": {
        loc: {
          start: {
            line: 90,
            column: 11
          },
          end: {
            line: 93,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 11
          },
          end: {
            line: 93,
            column: 5
          }
        }, {
          start: {
            line: 90,
            column: 11
          },
          end: {
            line: 93,
            column: 5
          }
        }],
        line: 90
      },
      "9": {
        loc: {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 101,
            column: 8
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 101,
            column: 8
          }
        }, {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 101,
            column: 8
          }
        }],
        line: 96
      },
      "10": {
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        }, {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        }],
        line: 113
      },
      "11": {
        loc: {
          start: {
            line: 136,
            column: 49
          },
          end: {
            line: 136,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 49
          },
          end: {
            line: 136,
            column: 58
          }
        }, {
          start: {
            line: 136,
            column: 62
          },
          end: {
            line: 136,
            column: 77
          }
        }],
        line: 136
      },
      "12": {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }, {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }],
        line: 146
      },
      "13": {
        loc: {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        }, {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        }],
        line: 154
      },
      "14": {
        loc: {
          start: {
            line: 161,
            column: 78
          },
          end: {
            line: 161,
            column: 113
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 78
          },
          end: {
            line: 161,
            column: 91
          }
        }, {
          start: {
            line: 161,
            column: 95
          },
          end: {
            line: 161,
            column: 113
          }
        }],
        line: 161
      },
      "15": {
        loc: {
          start: {
            line: 162,
            column: 9
          },
          end: {
            line: 162,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 162,
            column: 38
          },
          end: {
            line: 162,
            column: 43
          }
        }, {
          start: {
            line: 162,
            column: 46
          },
          end: {
            line: 162,
            column: 48
          }
        }],
        line: 162
      },
      "16": {
        loc: {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }, {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }],
        line: 165
      },
      "17": {
        loc: {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 173,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 173,
            column: 31
          }
        }, {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 173,
            column: 31
          }
        }],
        line: 173
      },
      "18": {
        loc: {
          start: {
            line: 175,
            column: 56
          },
          end: {
            line: 175,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 56
          },
          end: {
            line: 175,
            column: 77
          }
        }, {
          start: {
            line: 175,
            column: 81
          },
          end: {
            line: 175,
            column: 94
          }
        }],
        line: 175
      },
      "19": {
        loc: {
          start: {
            line: 199,
            column: 9
          },
          end: {
            line: 199,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 199,
            column: 9
          },
          end: {
            line: 199,
            column: 23
          }
        }, {
          start: {
            line: 199,
            column: 27
          },
          end: {
            line: 199,
            column: 49
          }
        }],
        line: 199
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Carousel/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Children } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { range } from '../utils/numbers';
import { carouselClass } from './styles';
import Item from './Item';
import getDataset from '../utils/dom/getDataset';
import { isRTL } from '../config';
var CarouselDefaultProps = (cov_ofz6c942s.s[0]++, {
  animation: 'slide',
  indicatorPosition: 'center',
  indicatorType: 'circle',
  interval: 0,
  className: '',
  style: {}
});

var Carousel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Carousel, _PureComponent);

  var _super = _createSuper2(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    cov_ofz6c942s.f[0]++;
    cov_ofz6c942s.s[1]++;
    _this = _super.call(this, props);
    _this.count = void 0;
    _this.$timeout = void 0;
    _this.mouseInView = void 0;

    _this.mouseEnterHandler = function () {
      cov_ofz6c942s.f[11]++;
      cov_ofz6c942s.s[42]++;
      _this.mouseInView = true;
      cov_ofz6c942s.s[43]++;

      _this.stop();
    };

    _this.mouseLeaveHandler = function () {
      cov_ofz6c942s.f[12]++;
      cov_ofz6c942s.s[44]++;
      _this.mouseInView = false;
      cov_ofz6c942s.s[45]++;

      _this.start();
    };

    cov_ofz6c942s.s[2]++;
    _this.state = {
      current: 0,
      direction: 'stop',
      pre: 0
    };
    cov_ofz6c942s.s[3]++;
    _this.start = _this.start.bind(_assertThisInitialized(_this));
    cov_ofz6c942s.s[4]++;
    _this.stop = _this.stop.bind(_assertThisInitialized(_this));
    cov_ofz6c942s.s[5]++;
    _this.moveTo = _this.moveTo.bind(_assertThisInitialized(_this));
    cov_ofz6c942s.s[6]++;
    _this.forward = _this.forward.bind(_assertThisInitialized(_this));
    cov_ofz6c942s.s[7]++;
    _this.backward = _this.backward.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_ofz6c942s.f[1]++;
      cov_ofz6c942s.s[8]++;

      _get(_getPrototypeOf(Carousel.prototype), "componentDidMount", this).call(this);

      cov_ofz6c942s.s[9]++;
      this.start();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_ofz6c942s.f[2]++;
      cov_ofz6c942s.s[10]++;

      if ((cov_ofz6c942s.b[1][0]++, this.count > 1) && (cov_ofz6c942s.b[1][1]++, !this.$timeout)) {
        cov_ofz6c942s.b[0][0]++;
        cov_ofz6c942s.s[11]++;
        this.start();
      } else {
        cov_ofz6c942s.b[0][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_ofz6c942s.f[3]++;
      cov_ofz6c942s.s[12]++;

      _get(_getPrototypeOf(Carousel.prototype), "componentWillUnmount", this).call(this);

      cov_ofz6c942s.s[13]++;
      this.stop();
    }
  }, {
    key: "setNext",
    value: function setNext(next) {
      var _this2 = this;

      cov_ofz6c942s.f[4]++;
      cov_ofz6c942s.s[14]++;

      if (this.mouseInView) {
        cov_ofz6c942s.b[2][0]++;
        cov_ofz6c942s.s[15]++;
        return;
      } else {
        cov_ofz6c942s.b[2][1]++;
      }

      var _ref = (cov_ofz6c942s.s[16]++, this.props),
          interval = _ref.interval;

      cov_ofz6c942s.s[17]++;

      if ((cov_ofz6c942s.b[4][0]++, interval > 0) && (cov_ofz6c942s.b[4][1]++, this.count > 1)) {
        cov_ofz6c942s.b[3][0]++;
        cov_ofz6c942s.s[18]++;
        this.stop();
        cov_ofz6c942s.s[19]++;
        this.$timeout = setTimeout(function () {
          cov_ofz6c942s.f[5]++;
          cov_ofz6c942s.s[20]++;

          _this2.moveTo(next);
        }, interval);
      } else {
        cov_ofz6c942s.b[3][1]++;
      }
    }
  }, {
    key: "moveTo",
    value: function moveTo(next) {
      cov_ofz6c942s.f[6]++;

      var _ref2 = (cov_ofz6c942s.s[21]++, this.props),
          onMove = _ref2.onMove;

      var _ref3 = (cov_ofz6c942s.s[22]++, this.state),
          current = _ref3.current;

      cov_ofz6c942s.s[23]++;

      if (next === current) {
        cov_ofz6c942s.b[5][0]++;
        cov_ofz6c942s.s[24]++;
        return;
      } else {
        cov_ofz6c942s.b[5][1]++;
      }

      var direction = (cov_ofz6c942s.s[25]++, next > current ? (cov_ofz6c942s.b[6][0]++, 'forward') : (cov_ofz6c942s.b[6][1]++, 'backward'));
      cov_ofz6c942s.s[26]++;

      if (next >= this.count) {
        cov_ofz6c942s.b[7][0]++;
        cov_ofz6c942s.s[27]++;
        direction = 'forward';
        cov_ofz6c942s.s[28]++;
        next = 0;
      } else {
        cov_ofz6c942s.b[7][1]++;
        cov_ofz6c942s.s[29]++;

        if (next < 0) {
          cov_ofz6c942s.b[8][0]++;
          cov_ofz6c942s.s[30]++;
          direction = 'backward';
          cov_ofz6c942s.s[31]++;
          next = this.count - 1;
        } else {
          cov_ofz6c942s.b[8][1]++;
        }
      }

      cov_ofz6c942s.s[32]++;
      this.setState({
        pre: current,
        current: next,
        direction: direction
      });
      cov_ofz6c942s.s[33]++;
      this.setNext(next + 1);
      cov_ofz6c942s.s[34]++;

      if (onMove) {
        cov_ofz6c942s.b[9][0]++;
        cov_ofz6c942s.s[35]++;
        onMove(next, {
          prev: current,
          direction: direction,
          moveTo: this.moveTo
        });
      } else {
        cov_ofz6c942s.b[9][1]++;
      }
    }
  }, {
    key: "forward",
    value: function forward() {
      cov_ofz6c942s.f[7]++;
      cov_ofz6c942s.s[36]++;
      this.moveTo(this.state.current + 1);
    }
  }, {
    key: "backward",
    value: function backward() {
      cov_ofz6c942s.f[8]++;
      cov_ofz6c942s.s[37]++;
      this.moveTo(this.state.current - 1);
    }
  }, {
    key: "stop",
    value: function stop() {
      cov_ofz6c942s.f[9]++;
      cov_ofz6c942s.s[38]++;

      if (this.$timeout) {
        cov_ofz6c942s.b[10][0]++;
        cov_ofz6c942s.s[39]++;
        clearTimeout(this.$timeout);
        cov_ofz6c942s.s[40]++;
        this.$timeout = null;
      } else {
        cov_ofz6c942s.b[10][1]++;
      }
    }
  }, {
    key: "start",
    value: function start() {
      cov_ofz6c942s.f[10]++;
      cov_ofz6c942s.s[41]++;
      this.setNext(this.state.current + 1);
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this3 = this;

      cov_ofz6c942s.f[13]++;

      var _ref4 = (cov_ofz6c942s.s[46]++, this.state),
          current = _ref4.current,
          pre = _ref4.pre;

      cov_ofz6c942s.s[47]++;
      return Children.toArray(this.props.children).map(function (child, i) {
        cov_ofz6c942s.f[14]++;
        cov_ofz6c942s.s[48]++;
        return (
          /*#__PURE__*/
          React.createElement(Item, {
            key: i,
            current: i === current,
            pre: (cov_ofz6c942s.b[11][0]++, i === pre) && (cov_ofz6c942s.b[11][1]++, pre !== current),
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 136,
              columnNumber: 7
            }
          }, child)
        );
      });
    }
  }, {
    key: "renderCustomIndicator",
    value: function renderCustomIndicator() {
      cov_ofz6c942s.f[15]++;

      var _ref5 = (cov_ofz6c942s.s[49]++, this.props),
          indicatorType = _ref5.indicatorType,
          indicatorPosition = _ref5.indicatorPosition;

      var _ref6 = (cov_ofz6c942s.s[50]++, this.state),
          current = _ref6.current;

      var className = (cov_ofz6c942s.s[51]++, carouselClass('indicator', "indicator-".concat(indicatorPosition)));
      cov_ofz6c942s.s[52]++;

      if (typeof indicatorType === 'function') {
        cov_ofz6c942s.b[12][0]++;
        cov_ofz6c942s.s[53]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: className,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 147,
              columnNumber: 14
            }
          }, indicatorType(current, this.moveTo))
        );
      } else {
        cov_ofz6c942s.b[12][1]++;
      }

      cov_ofz6c942s.s[54]++;
      return null;
    }
  }, {
    key: "renderIndicator",
    value: function renderIndicator() {
      var _this4 = this;

      cov_ofz6c942s.f[16]++;

      var _ref7 = (cov_ofz6c942s.s[55]++, this.props),
          indicatorPosition = _ref7.indicatorPosition,
          indicatorType = _ref7.indicatorType;

      cov_ofz6c942s.s[56]++;

      if (typeof indicatorType === 'function') {
        cov_ofz6c942s.b[13][0]++;
        cov_ofz6c942s.s[57]++;
        return this.renderCustomIndicator();
      } else {
        cov_ofz6c942s.b[13][1]++;
      }

      var _ref8 = (cov_ofz6c942s.s[58]++, this.state),
          current = _ref8.current;

      var className = (cov_ofz6c942s.s[59]++, carouselClass('indicator', "indicator-".concat(indicatorPosition), "indicator-".concat(indicatorType)));
      var inds = (cov_ofz6c942s.s[60]++, range(this.count).map(function (i) {
        cov_ofz6c942s.f[17]++;
        cov_ofz6c942s.s[61]++;
        return (
          /*#__PURE__*/
          React.createElement("a", {
            key: i,
            onClick: _this4.moveTo.bind(_this4, i),
            className: carouselClass((cov_ofz6c942s.b[14][0]++, current === i) && (cov_ofz6c942s.b[14][1]++, 'indicator-active')),
            __self: _this4,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 161,
              columnNumber: 7
            }
          }, indicatorType === 'number' ? (cov_ofz6c942s.b[15][0]++, i + 1) : (cov_ofz6c942s.b[15][1]++, ''))
        );
      }));
      cov_ofz6c942s.s[62]++;

      if (isRTL()) {
        cov_ofz6c942s.b[16][0]++;
        cov_ofz6c942s.s[63]++;
        inds.reverse();
      } else {
        cov_ofz6c942s.b[16][1]++;
      }

      cov_ofz6c942s.s[64]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 168,
            columnNumber: 12
          }
        }, inds)
      );
    }
  }, {
    key: "renderArrow",
    value: function renderArrow() {
      cov_ofz6c942s.f[18]++;

      var _ref9 = (cov_ofz6c942s.s[65]++, this.props),
          arrowClassName = _ref9.arrowClassName,
          showArrow = _ref9.showArrow;

      cov_ofz6c942s.s[66]++;

      if (!showArrow) {
        cov_ofz6c942s.b[17][0]++;
        cov_ofz6c942s.s[67]++;
        return null;
      } else {
        cov_ofz6c942s.b[17][1]++;
      }

      cov_ofz6c942s.s[68]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(carouselClass('arrow', (cov_ofz6c942s.b[18][0]++, showArrow === 'hover') && (cov_ofz6c942s.b[18][1]++, 'arrow-hover')), arrowClassName),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 175,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: carouselClass('arrow-left'),
          onClick: this.backward,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 176,
            columnNumber: 9
          }
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: carouselClass('arrow-right'),
          onClick: this.forward,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 177,
            columnNumber: 9
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_ofz6c942s.f[19]++;
      cov_ofz6c942s.s[69]++;
      this.count = Children.toArray(this.props.children).length;

      var _ref10 = (cov_ofz6c942s.s[70]++, this.props),
          animation = _ref10.animation,
          style = _ref10.style;

      var _ref11 = (cov_ofz6c942s.s[71]++, this.state),
          direction = _ref11.direction;

      var className = (cov_ofz6c942s.s[72]++, classnames(carouselClass('_', animation, direction), this.props.className));
      cov_ofz6c942s.s[73]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          style: style,
          onMouseEnter: this.mouseEnterHandler,
          onMouseLeave: this.mouseLeaveHandler
        }, getDataset(this.props), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 190,
            columnNumber: 7
          }
        }), this.renderItems(), this.renderArrow(), (cov_ofz6c942s.b[19][0]++, this.count > 1) && (cov_ofz6c942s.b[19][1]++, this.renderIndicator()))
      );
    }
  }]);

  return Carousel;
}(PureComponent);

Carousel.defaultProps = CarouselDefaultProps;
Carousel.displayName = 'ShineoutCarousel';
export default Carousel;